<template lang="pug">

.lino
  .lino-intro.u-section-full.u-section-padding.u-textCenter
    h1.u-mb-xm {{$t('pageTitle')}}
    h5.u-mb-xm {{$t('mantra')}}
    p.u-mb-xm {{$t('mantraDesc')}}
    img.u-mb-xm(src='https://cdn.baianat.com/static/resources/lino/1.png', srcset='https://cdn.baianat.com/static/resources/lino/1.png 1x, https://cdn.baianat.com/static/resources/lino/1@2x.png 2x')
    AppLink(to="https://baianat.com/files/file1fr2q01jr64ze3c" class="button is-rounded is-wide is-white") {{$t('downloadIcons')}}



  section.lino-yellow.u-section-full.u-textCenter
    img.lino-yellow-img.u-mb-xm(src='https://cdn.baianat.com/static/resources/lino/2.png', srcset='https://cdn.baianat.com/static/resources/lino/2.png 1x, https://cdn.baianat.com/static/resources/lino/2@2x.png 2x')
    .u-mt-lg
      h2.u-mb-xm +1000
      p.u-mb-xm(v-html="$t('vitalLusty')")
      AppLink(to="https://baianat.com/files/file1fr2q01jr64ze3c" class="button is-rounded is-wide is-black") {{$t('download')}}
    .u-mt-lg
      img.u-img(src='https://cdn.baianat.com/static/resources/lino/3.png', srcset='https://cdn.baianat.com/static/resources/lino/3.png 1x, https://cdn.baianat.com/static/resources/lino/3@2x.png 2x')



  section.u-cl-white.u-mh-lg
    .u-textCenter
      h2.u-mb-0 120
      h4.u-mh-xm  {{$t('freeCollection')}}
      AppLink(to="/" class="button is-rounded is-wide is-white") {{$t('download')}}
      .u-mh-md.u-textCenter
        img(src='https://cdn.baianat.com/static/resources/lino/4.png', srcset='https://cdn.baianat.com/static/resources/lino/4.png 1x, https://cdn.baianat.com/static/resources/lino/4@2x.png 2x')

    h4.u-mb-xm {{$t('WhoBenifits')}}
    .grid.is-desktop-4
      .column.u-mb-xm
        h5 {{$t('designers')}}
        p {{$t('designersDesc')}}
      .column.u-mb-xm
        h5 {{$t('developers')}}
        p {{$t('developersDesc')}}
      .column.u-mb-xm
        h5 {{$t('details')}}
        p(v-for="item in $t('detailsItems')") {{item}}


    img(src='https://cdn.baianat.com/static/resources/lino/5.png', srcset='https://cdn.baianat.com/static/resources/lino/5.png 1x, https://cdn.baianat.com/static/resources/lino/5@2x.png 2x')


  section.lino-features.u-section-full.u-section-padding
    .grid.is-desktop-4
      .column.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/lino/6.png', srcset='https://cdn.baianat.com/static/resources/lino/6.png 1x, https://cdn.baianat.com/static/resources/lino/6@2x.png 2x')
        h4.u-mh-xs {{$t('resizable')}}
        p {{$t('resizableDesc')}}
      .column.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/lino/7.png', srcset='https://cdn.baianat.com/static/resources/lino/7.png 1x, https://cdn.baianat.com/static/resources/lino/7@2x.png 2x')
        h4.u-mh-xs {{$t('customizable')}}
        p  {{$t('customizableDesc')}}
      .column.u-mb-sm
        img(src='https://cdn.baianat.com/static/resources/lino/8.png', srcset='https://cdn.baianat.com/static/resources/lino/8.png 1x, https://cdn.baianat.com/static/resources/lino/8@2x.png 2x')
        h4.u-mh-xs {{$t('scalable')}}
        p {{$t('scalableDesc')}}


  section.lino-cta.u-section-full.u-section-padding.u-textCenter
      h2.u-mb-xs {{$t('linoIcons')}}
      p.u-mb-xm.u-text-lg {{$t('coloredWired')}}
      p.u-mb-xm {{$t('coloredWiredDesc')}}
      AppLink(to="https://baianat.com/files/file1fr2q01jr64ze3c" class="button is-rounded is-wide is-white" :title="$t('download')") {{$t('download')}}


</template>

<style lang="stylus">
$clMain = #d51a12
$clDark = #1b1d1f
$clBlue = #0ac8fb
$clYellow = #ffbf06
$clGreen = #0cb04a

div.app.is-lino
  overflow: hidden
  background: $clMain

  .header.is-scroll
    background: $clMain
    color: $clWhite !important

  .footer
    border-top: none
    color: $clWhite

.lino
  position: relative
  z-index: 1

  &-intro
    background: $clMain
    color: $clWhite
    padding-top: unitRes(240, 300)
    padding-bottom: unitRes(280, 700)
    z-index: 1
    position: relative
    text-shadow: 1px 1px 11px alpha($clBlack, 0.2)
    overflow: hidden

  &-yellow
    background: $clYellow
    padding-bottom: unitRes(100, 200)
    position: relative
    z-index: 2

    &-img
      margin-top: -500px

      +mq($until: 1600px)
        margin-top: -30%

  &-features
    background: $clBlue
    color: $clWhite
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(100, 200)

  &-cta
    background: $clDark
    color: $clWhite
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(100, 200)
</style>

<script>
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,

  meta: {
    theme: 'is-lino is-whiteHeader is-fixedHeader',
    logoText: '__NONE__'
  },
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Lino",
    "pageDesc":"Enjoy designing with +1000 icons in more than one field. The icons are provided with two styles to support your design look and feel.",
    "mantra":"COLORED - WIRED ICONS",
    "mantraDesc":"Enjoy designing with more than 1000 icons #[br] in more than one field",
    "downloadIcons":"Download Icons",
    "vitalLusty":"Use lino icons with its vital lusty colors that bring <br> life into your design.",
    "download":"Download",
    "freeCollection":"Free collection icons",
    "WhoBenifits":"Who benifits",
    "designers":"Designers",
    "designersDesc":"Enjoy Lino icons on any platform you are using, PSD, AI, Sketch or even PNG.",
    "developers":"Developers",
    "developersDesc":"SVG icons format are made for you to serve and facilitate your work process.",
    "details":"Details",
    "detailsItems":{
      "1":"Type: Colored + Wired",
      "2":"Format: Ai - PSD - Sketsh - SVG",
      "3":"Count: 1000",
      "4":"Size: 27.9 MB",
      "5":"Licence: Commercial"
    },
    "resizable":"Resizable",
    "resizableDesc":"To ensure Lino icons perfection, sharpness and consistency, all of them are created on a grid of 64px.",
    "customizable":"Customizable",
    "customizableDesc":"Enjoy Lino icons as much as you want, as you can customize its colors or sizes to what suits you.",
    "scalable":"Scalable",
    "scalableDesc":"To fulfill all your design needs, Lino icons come to you in two different styles, colored and wired.",
    "linoIcons":"Lino Icons",
    "coloredWired":"Colored - Wired",
    "coloredWiredDesc":"Use lino icons with its vital lusty colors that bring #[br] life into your design.",
    "download":"Download"
  },
  "ar": {
    "pageTitle":"أيقونات لينو",
    "pageDesc":"استمتع بالتصميم باستخدام +1000 أيقونات في أكثر من مجال واحد. تم تزويد الأيقونات بنمطين  الداكن والفاتح لدعم شكل التصميم.",
    "mantra":"أيقونات ملونة وخطية",
    "mantraDesc":"استمتع بأكثر من 1000 أيقونة في أكثر من مجال لتصميمات جذابة",
    "downloadIcons":"تحميل",
    "vitalLusty":"استخدم أيقونات لينو الملونة التي تمنح تصميمك الحياة والواقعية",
    "download":"تحميل",
    "freeCollection":"مجموعة أيقونات مجانية",
    "WhoBenifits":"تم تصميمها من أجل",
    "designers":"المصممون",
    "designersDesc":"تمتع بأيقونات لينو على أي نظام أساسي تستخدمه، بما في ذلك PS أو AI أو Sketch أو حتى PNG.",
    "developers":"المطورون",
    "developersDesc":"تم تصميم رموز SVG لتسهيل سير عملك وإنهائه في دقائق.",
    "details":"التفاصيل",
    "detailsItems":{
      "1":"النوع: ملون + خطي",
      "2":"التنسيق: Ai - PSD - Sketch - SVG",
      "3":"العدد: 1000",
      "4":"الحجم: 27.9 MB",
      "5":"الترخيص: تجاري"
    },
    "resizable":"قابلة لتغيير حجمها",
    "resizableDesc":"لضمان تحقيق أيقونة لينو الكمال والاتساق، تم إنشاء جميع الأيقونات على شبكة بحجم 64 بكسل.",
    "customizable":"مخصصة",
    "customizableDesc":"استمتع بأيقونات لينو بالشكل الذي تريده حيث يمكنك تخصيص ألوانها وأحجامها بما يناسبك.",
    "scalable":"ألوان غير محدودة",
    "scalableDesc":"لتحصل على كل ما يحتاجه تصميمك، تأتي أيقونات لينو بنمطين مختلفين، ملون وخطي.",
    "linoIcons":"أيقونات لينو",
    "coloredWired":"ملونة - خطية",
    "coloredWiredDesc":"استمتع بمجموعة متنوعة من آلاف الأيقونات التي تجعل تصميماتك مفعمة بالحياة.",
    "download":"تحميل"
  }
}
</i18n>
